// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--oDiet";
export var blog__body = "blog-module--blog__body--3yaOn";
export var blog__footer = "blog-module--blog__footer--cPVwz";
export var blog__hero = "blog-module--blog__hero--F5hyu";
export var blog__info = "blog-module--blog__info--1n34m";